module.exports = __webpack_public_path__ + "static/media/outPutPic.64647b55.svg";